<template>
	<LayoutAuth>
		<form class="form form--auth" @submit.prevent="onSubmit" novalidate>
			<ValidationAlert :errorList="errors.collect('server')"></ValidationAlert>

			<div class="form__group">
				<label class="form__label" for="username">Email Address</label>
				<input id="username" type="text" name="username"
				       class="form__control"
				       placeholder="Enter your email address here" required
				       v-model="formData.username" v-validate autocomplete="username" autofocus  />
			</div>

			<div class="form__group">
				<label class="form__label" for="password">Password</label>
				<input id="password" type="password" name="password"
				       class="form__control"
				       placeholder="Enter your password here" required
				       v-model="formData.password" v-validate autocomplete="current-password" />
				<router-link class="forgot" to="/login/forgot-password">
					<span>Forgot password</span>
				</router-link>
			</div>

			<div class="form__group form__group--submit">
				<button type="submit" class="btn btn--primary" :disabled="$wait.is('login')">Login</button>
			</div>
		</form>
	</LayoutAuth>
</template>

<script>
	import { mapWaitingActions } from 'vue-wait';
	import API from './../api';
	import LayoutBase from './Layout/LayoutBase.vue';
	import SvgIcon from './SvgIcon';
	import ValidationAlert from './ValidationAlert';
	import LayoutAuth from './Layout/LayoutAuth';

	export default {
		components: {
			LayoutAuth,
			ValidationAlert,
			SvgIcon,
		},
		data() {
			return {
				formData: {
					username: '',
					password: '',
				},
			}
		},
		methods: {
			...mapWaitingActions([
				'login',
			]),
			onSubmit() {
				this.$validator.validateAll().then((result) => {
					if(result) {
						this.$wait.start('login');

						this.login(this.formData).then(() => {
							this.$router.push('/dashboard');
						}).catch(error => {
							API.mapServerValidation(error.response, this.$validator);
						}).finally(() => {
							this.$wait.end('login');
						});
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";
	@import '~@/mixins/_class.scss';

	.forgot {
		position: absolute;
		right: 0;
		top: 0;
		font-size: 1.2rem;
	}
</style>
